import { InquiryEntryType } from '@interfaces/inquiries';
import { DetailsAtTopMetaData } from '@store/features/adminInquiries/inquiryEntryDetails/slice.interface';
import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.adminInquiries.inquiryEntryDetails;
export const adminInquiryEntryDetailsActiveIdSelector = (state: RootState) =>
  getState(state).activeId;
export const adminSupplementDetailsSelector = (state: RootState) =>
  getState(state).supplementDetails;
export const adminInquiryEntryDetailsIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const adminInquiryEntryDetailsErrorSelector = (state: RootState) => getState(state).error;
export const adminInquiryEntryDetailsIsDeactivatingSelector = (state: RootState) =>
  getState(state).isDeactivating;
export const adminSupplementDetailsStatusSelector = (state: RootState) =>
  adminSupplementDetailsSelector(state)?.adminSupplementInquiryStatusId;
export const adminMedicationDetailsSelector = (state: RootState) =>
  getState(state).medicationDetails;

export const adminMedicationDetailsStatusSelector = (state: RootState) =>
  adminMedicationDetailsSelector(state)?.adminSupplementInquiryStatusId;

export const adminActiveInquiryEntryTypeSelector = (state: RootState) =>
  getState(state).activeEntryType;

export const adminActiveInquiryEntryMetaDataSelector = (
  state: RootState,
): DetailsAtTopMetaData | null => {
  const type = adminActiveInquiryEntryTypeSelector(state);
  const supplement = adminSupplementDetailsSelector(state);
  const medication = adminMedicationDetailsSelector(state);
  if (type === InquiryEntryType.Supplement) {
    if (!supplement) {
      return null;
    }
    const {
      adminSupplementInquiryStatusId: entryStatusId,
      organizationId,
      supplementInquiryId: entryInquiryId,
      submittedOn,
      lastUpdatedBy,
      lastUpdatedOn,
    } = supplement;
    return {
      entryStatusId,
      organizationId,
      entryInquiryId,
      submittedOn,
      lastUpdatedBy,
      lastUpdatedOn,
    };
  }
  if (type === InquiryEntryType.Medication) {
    if (!medication) {
      return null;
    }
    const {
      adminSupplementInquiryStatusId: entryStatusId,
      organizationId,
      medicationInquiryId: entryInquiryId,
      submittedOn,
      lastUpdatedBy,
      lastUpdatedOn,
    } = medication;
    return {
      entryStatusId,
      organizationId,
      entryInquiryId,
      submittedOn,
      lastUpdatedBy,
      lastUpdatedOn,
    };
  }
  return null;
};
